module.exports = __webpack_public_path__ + "img/eight3Orange.fc520661.jpg";